// Convert Latin digits to Persian digits when locale is 'fa'
export default {
    methods: {
        toPersian(num) {
            if (this.$store.getters.getLocale !== 'fa') return num
            return String(num).replace(/[0-9]/g, d => '۰۱۲۳۴۵۶۷۸۹'[d])
        }
    }
}
